import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeInitializerService } from './utils/theme-initializer.service';
import { AuthService } from './auth/auth.service';
import { ToasterService } from './providers/toaster/toaster.service';
import { ToasterComponent } from "./providers/toaster/toaster.component";
import { CommonApiDataServiceService } from './pages/services/common-api-data-service.service';
import { take } from 'rxjs';
import { Action } from 'rxjs/internal/scheduler/Action';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToasterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'teacherFactor-FrontendAngular';

  constructor(private themeInitalize: ThemeInitializerService, private authService: AuthService, private commonApiDataService: CommonApiDataServiceService) {


  }
  ngOnInit(): void {
    this.themeInitalize.initializeTheme();
    // this.authService.isUserAuthenticated()
    //   .pipe(take(1))
    //   .subscribe((res) => {
    //     if (res) {
    //       this.commonApiDataService.getAcademicSetupMetadata();
    //     }
    //   });
  }

}